<template>
  <div class="basic_wrap recharge-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('moneybag.rechargeRecord') }}
      </div>
    </div>

    <section class="balance-card">
      <p>{{ $t('moneybag.accountBalance') }}</p>
      <strong>{{ utils_moneyMark() }} {{ funds.toFixed(0) }}</strong>
    </section>

    <div class="detail_box">
      <van-empty
        v-if="listShow"
        :description="$t('item.noData')"
      />
      <article
        v-for="(item, index) in data"
        v-else
        :key="item.id || item.orderid || index"
        class="record-card"
      >
        <div class="de_wrap">
          <div class="record-title">
            <span>{{ $t('invest_qrcode.recharge') }}</span>
            <strong
              class="record-status"
              :class="getRechargeStatusClass(item)"
            >
              {{ getRechargeStatusText(item) }}
            </strong>
          </div>
          <p
            v-if="item.memo != null"
            class="time memo"
          >
            {{ $t('cash.remark') }}: {{ item.memo }}
          </p>
          <p class="time">
            {{ item.orderid }}
          </p>
          <p class="time">
            {{ item.time }}
          </p>
        </div>
        <div
          class="price"
          :class="getRechargeAmountClass(item)"
        >
          {{ formatRechargeAmount(item) }}
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Empty } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Empty);

export default {
	name: "RechargeRecord",
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			data: [],
			list: {},
			account: 0,
			option: [],
			listShow: false,
			funds: 0,
			mymoney: 0,
			userName: "",
		};
	},
	created() {
		this.$parent.footer("user", false);
	},
	mounted() {
		Fetch("/user/funds", {
			reason_id: 1,
		}).then(r => {
			this.option.push({
				text: this.$t("moneybag.types"),
				value: 0,
			});

			this.mymoney = r.data.mymoney;
			this.funds = parseInt(r.data.money);
			this.userName = r.data.username;
		});

		Fetch("/user/recharge_search").then(r => {
			var list = r.data || [];

			this.showError(list.length);
			this.data = list;
		});
	},
	methods: {
		chooseType(val) {
			if (val == 0) {
				Fetch("/user/funds").then(r => {
					this.data = r.data.list;
					this.showError(r.data.list.length);
				});
			} else {
				Fetch("/user/funds", {
					reason_id: val,
				}).then(r => {
					this.data = r.data.list;
					this.showError(r.data.list.length);
				});
			}
		},
		formatRechargeAmount(item) {
			var amount = parseInt(item.money);

			if (isNaN(amount)) {
				amount = 0;
			}

			return this.utils_moneyMark() + amount;
		},
		getRechargeStatusText(item) {
			if (String(item.status) === "1") {
				return this.$t("invest.success");
			}
			if (String(item.status) === "2") {
				return this.$t("invest.failed");
			}
			return this.$t("invest_qrcode.submittedSuccessfully");
		},
		getRechargeStatusClass(item) {
			if (String(item.status) === "1") {
				return "is-success";
			}
			if (String(item.status) === "2") {
				return "is-fail";
			}
			return "is-pending";
		},
		getRechargeAmountClass(item) {
			if (String(item.status) === "1") {
				return "is-success";
			}
			if (String(item.status) === "2") {
				return "is-fail";
			}
			return "is-pending";
		},
		showError(len) {
			this.listShow = len === 0;
		},
	},
};
</script>

<style lang="less" scoped>
.recharge-page {
	min-height: 100vh;
	background: #111;
	color: #f6f6f6;
	padding-bottom: 80px;
	box-sizing: border-box;
}

.page-top {
	height: 44px;
	background: #111;
	color: #f6f6f6;
	border-bottom: 1px solid #242424;
	box-sizing: border-box;

	.back_left {
		filter: invert(1);
		opacity: 0.88;
	}

	.big_tit {
		color: #f6f6f6;
	}
}

.balance-card {
	margin: 16px 16px 0;
	padding: 20px 18px;
	border-radius: 12px;
	border: 1px solid #303030;
	background: #222;
	box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
	text-align: center;
	box-sizing: border-box;
}

.balance-card p {
	color: #c6cad2;
	font-size: 14px;
	line-height: 20px;
}

.balance-card strong {
	display: block;
	margin-top: 10px;
	color: #8ea0ff;
	font-size: 20px;
	font-weight: 700;
	line-height: 28px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.detail_box {
	padding: 16px 16px 0;
}

.record-card {
	margin-bottom: 14px;
	padding: 17px 18px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: 12px;
	border: 1px solid #303030;
	background: #222;
	box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
	box-sizing: border-box;
}

.de_wrap {
	min-width: 0;
	flex: 1;
}

.record-title {
	display: flex;
	align-items: center;
	min-width: 0;
}

.record-title span {
	min-width: 0;
	color: #f6f6f6;
	font-size: 14px;
	font-weight: 700;
	line-height: 22px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.record-status {
	flex: 0 0 auto;
	margin-left: 8px;
	font-size: 12px;
	line-height: 18px;
	white-space: nowrap;
}

.time {
	margin-top: 8px;
	color: #9aa1aa;
	font-size: 12px;
	line-height: 18px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.memo {
	white-space: normal;
	word-break: break-word;
}

.price {
	flex: 0 0 auto;
	max-width: 38%;
	margin-left: 14px;
	font-size: 16px;
	font-weight: 700;
	line-height: 24px;
	text-align: right;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.is-success {
	color: #12ed72;
}

.is-fail {
	color: #ff4a4a;
}

.is-pending {
	color: #8ea0ff;
}

/deep/ .van-empty {
	padding-top: 72px;
}

/deep/ .van-empty__description {
	color: #9aa1aa;
}


.basic_btn,
.history_coupon,
.wallet-btn.is-primary,
.allbtn {
  border: 0;
  background: linear-gradient(100deg, #657be9 0%, #8c52bd 100%) !important;
  color: #fff;
}


.page-top {
  background: #101010;
}

@media screen and (max-width: 374px) {
	.balance-card,
	.detail_box {
		margin-right: 12px;
		margin-left: 12px;
	}

	.detail_box {
		padding-right: 0;
		padding-left: 0;
	}

	.record-card {
		padding-right: 14px;
		padding-left: 14px;
	}

	.price {
		max-width: 34%;
		font-size: 14px;
	}
}
</style>
